<template>
  <van-popup v-model:show="isShow" position="bottom" closeable round safe-area-inset-bottom>
    <div class="box" v-if="isShow">
      <span v-if="preView" class="themeRed">这是一个预览页面</span>
      <h2 class="title">确认商品</h2>
      <div class="fvlr goods">
        <div class="imgBox">
          <img v-if="skuItem?.thumbnail" :src="skuItem?.thumbnail" />
          <img v-else :src="datas?.shopInfoDatas?.thumbnail" />
        </div>
        <div class="fhlu">
          <div class="name ellipsisRow">{{ datas?.shopInfoDatas?.productName }}</div>
          <div class="price">{{ getPrice() }}</div>
        </div>
      </div>
      <!-- skuItem?.thumbnail{{ skuItem?.thumbnail }} -->
      <!-- {{ skuItem }} -->
      <!-- {{ min }}--{{ max }} -->
      <!-- devTemp -->
      <!-- currentSkuLis{{ currentSkuLis.length }} <br />allSalesAttributes:{{ salesAttributes?.length }}
      <div>isShowAttributes{{ isShowAttributes }}</div>-->
      <!-- <div>selectShopVariantItem{{ selectShopVariantItem }}</div> -->
      <!-- allSalesAttributes:{{ salesAttributes }} -->
      <!-- <hr />
      variantsListData:{{ variantsListData }} -->
      <!-- currentSkuLis{{ currentSkuLis }} -->
      <div class="sectionBox" v-show="isShowAttributes">
        <VariantsList :datas="variantsListData" :isEWProduct="isEWProduct" />
      </div>
      <div class="sectionBox" v-if="isShowChange">
        经销商无可售商品，请切换经销商
      </div>

      <div class="sectionBox">
        <div class="row">车辆：{{ preView ? 'XXXXXX' : datas?.carInfoTxt }}</div>
        <div class="row ellipsis">销售经销商：{{ preView ? 'XXXXXX' : dealerInfo?.name }}</div>
        <div class="fvlr row">
          <div>购买数量</div>
          <van-stepper :disabled="preView || isEWProduct" @change="handleStep"  :before-change="beforeQuantityChange" disable-input v-model="productNum" :min="min" :max="max" button-size="22" />
        </div>
        <div class="row" v-if="preView" @click="viewContract">告知书：<span class="underline themeColor"> 点我预览 </span></div>
      </div>
      <div class="btn">
        <van-button @click="clickSureBtn" :disabled="sureBtnDisableBool" type="primary" block>{{ isChecking ? '信息校验中...' : '确 定' }}</van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { reactive, toRefs, watch, computed, onMounted, nextTick } from 'vue'
import VariantsList from '@/components/shop/VariantsList'
import { useStore } from 'vuex'
import { onBeforeRouteLeave } from 'vue-router'
import { showToast } from '@/util/couponCollection'
import { isNum } from '@/util/index'
import _ from 'lodash'
import useCurrentCarInfo from '@/hooks/directSales/useCurrentCarInfo'
import { bindOrderForCustomer } from '@/api/directSales'

export default {
  components: {
    VariantsList
  },
  emits: ['updateShoppingSuccess', 'clickSureBtn', 'viewContract'],
  props: ['datas', 'showTyreNum', 'from', 'type'],
  setup(props, { emit }) {
    const store = useStore()
    let { datas, showTyreNum, from, type } = toRefs(props)
    let { currentGoodsInfo, dealerInfo } = store.state
    const { initCarInfo } = useCurrentCarInfo()
    const state = reactive({
      isorderNo: false,
      isShow: false,
      datas,
      showTyreNum,
      goodsInfo: currentGoodsInfo,
      dealerInfo,
      productNum: 1,
      stepperNum: 1,
      maxN: 99,
      max: 99,
      min: 1,
      noNtockMsg: '该经销商无可售商品，请切换经销商',
      from,
      type,
      skuItem: {},
      selectVariantItemFirst: {}
    })
    onBeforeRouteLeave(async () => {
      state.isShow = false
      let { selectShopVariantItemFirst, selectShopVariantItem } = store.state
      let data = store.state.currentBuyProductInfo
      if (!state.datas?.shopInfoDatas?.orderNo) return
      if (
        state.productNum != state.stepperNum ||
        selectShopVariantItemFirst?.oilType?.code != selectShopVariantItem?.oilType?.code ||
        selectShopVariantItemFirst?.serviceContent?.code != selectShopVariantItem?.serviceContent?.code
      ) {
        // showToast(' 商品加购件数已达到最大购买量1件')
        data.shopData.orderNo = undefined
        store.dispatch('setCurrentBuyProductInfo', data)
        // console.log('onBeforeRouteLeave', '11111')
      }
      // else {
      //   if (data?.shopData?.orderNo) {
      //     let dd = { orderNo: data?.shopData?.orderNo }
      //     try {
      //       let obj = await bindOrderForCustomer({ ...dd })
      //       data.shopData.customerCarId = obj?.customerCarId
      //       store.dispatch('setCurrentBuyProductInfo', data)
      //     } catch (error) {
      //       showToast(error.message)
      //       return
      //     }
      //   }
      // }
      // console.log('onBeforeRouteLeave', selectShopVariantItemFirst, store.state.selectShopVariantItem)
    })
    const closePop = () => {
      state.isShow = false
    }
    const viewContract = () => {
      emit('viewContract', { ...state.skuItem })
    }
    const getPrice = () => {
      let suggestPrice = state.datas?.shopInfoDatas?.suggestPrice || ''
      let skuPrice = state.skuItem?.price
      let loyaltyDealerInfo = store.state.loyaltyDealerInfo
      let gsCode = loyaltyDealerInfo.gsCode || loyaltyDealerInfo.gs_code
      if (preView.value) {
        return ``
      }
      if (!gsCode) {
        return `零售价 ¥${suggestPrice} 起`
      }
      if (isNum(skuPrice)) {
        return `零售价 ¥${skuPrice}`
      } else {
        if (isEWProduct.value) {
          const dealerPrice = state.datas?.shopInfoDatas?.dealerPrice ?? ''
          return `零售价 ¥${dealerPrice} 起`
        }
        return `零售价 ¥${suggestPrice} 起`
      }
    }
    const orderNoYes = computed(() => {
      let { selectShopVariantItemFirst, selectShopVariantItem } = store.state
      if (!state.datas?.shopInfoDatas?.orderNo) return false
      if (
        state.productNum != state.stepperNum ||
        selectShopVariantItemFirst?.oilType?.code != selectShopVariantItem?.oilType?.code ||
        selectShopVariantItemFirst?.serviceContent?.code != selectShopVariantItem?.serviceContent?.code ||
        selectShopVariantItemFirst?.salesAttributeServiceContent?.code != selectShopVariantItem?.salesAttributeServiceContent?.code ||
        selectShopVariantItemFirst?.salesAttributeServiceDuration?.code != selectShopVariantItem?.salesAttributeServiceDuration?.code
      ) {
        return true
      }
      return false
    })
    const preView = computed(() => !!state.datas?.preView)
    const isEWProduct = computed(() => state.datas?.sign === 'ewProduct')
    const isChecking = computed(() => state.datas?.shopInfoDatas?.isChecking)
    const currentSkuLis = computed(() => state.datas?.shopInfoDatas?.currentSkuLis || [])
    const salesAttributes = computed(() => state.datas?.shopInfoDatas?.salesAttributes || [])
    const selectShopVariantItem = computed(() => store.state.selectShopVariantItem || {})
    const variantsListData = computed(() => {
      /*
       -------------salesAttributes---
       [ {
        code: "serviceContent" ,name: "服务内容"
        values: [{lable: "4A", code: "4A"}, {lable: "2A", code: "2A"}, {lable: "6A", code: "6A"}]
        }]
      ----------currentSkuLis----------
      // ;[
      //   { skuId: '1544943930118098945', serviceContent: '4A', oilType: 'AMG', price: 2 //价格 },
      //   { skuId: '1544943930214567937', serviceContent: '6A', oilType: 'AMG', price: 3 //价格  }
      // ]
        ---------selectShopVariantItem---------
        oilType: {lable: "普通机油", code: "MB", disable: true, pid: "oilType", pName: "机油类型"}
        serviceContent: {lable: "6A", code: "6A", disable: true, pid: "serviceContent", pName: "服务内容"}
      **/
      let currentSkuLisData = currentSkuLis.value
      let allSalesAttributes = salesAttributes.value
      let variantItem = selectShopVariantItem.value
      let getDisableBool = (attrCode, valCode) => {
        if (variantItem) {
          if (variantItem[attrCode]) {
            // 已选中该类属性
            if (variantItem[attrCode]?.code === valCode) {
              return false
            } else {
              // 找到包含valCode的sku
              let res = currentSkuLisData.filter(sku => sku[attrCode] === valCode)
              let variantItemValArr = Object.values(variantItem)
              let findRes = false
              for (let index = 0; index < variantItemValArr.length; index++) {
                const element = variantItemValArr[index]
                let elFind = res.find(sku => {
                  if (element.pid === attrCode) {
                    return false
                  } else {
                    return sku[element.pid] === element.code
                  }
                })
                if (elFind) {
                  findRes = true
                  break
                }
              }
              return res && res?.length > 0 ? !findRes : true
            }
          } else {
            // 未选中该类属性
            let res = currentSkuLisData.filter(sku => Object.values(variantItem).every(item => sku[item.pid] === item.code))
            return res && res?.length && !res.find(item => item[attrCode] === valCode)
          }
        } else {
          return false
        }
      }
      let res =
        (allSalesAttributes &&
          allSalesAttributes.length &&
          allSalesAttributes
            .filter(attr => currentSkuLisData.some(sku => _.has(sku, attr.code)))
            // .map(attr => ({ ...attr, values: attr.values.filter(val => currentSkuLisData.some(sku => sku[attr.code] === val.code)) }))
            .map(attr => ({
              ...attr,
              values: attr.values.map(val => {
                return {
                  ...val,
                  disable: getDisableBool(attr.code, val.code)
                }
              })
            }))
            .filter(attr => attr.values.length)) ||
        []
      return res
    })
    const handleStep = () => {
      nextTick(() => {
        if (state.isorderNo) {
          state.productNum = 1
          showToast(' 商品加购件数已达到最大购买量1件')
        }
      })
    }
    const isShowAttributes = computed(
      () => state.datas?.sign === 'ewProduct' || (state.datas?.shopInfoDatas?.uploadSkuCount > 1 && variantsListData.value.length)
    )
    const isShowChange = computed(() => state.datas?.shopInfoDatas?.uploadSkuCount > 1 && variantsListData.value.length === 0)
    const sureBtnDisableBool = computed(() => !!(preView.value || isChecking.value || state.productNum < 1))
    watch(
      () => variantsListData.value,
      variantsListData => {
        if (variantsListData && variantsListData.length) {
          let ShopVariantItem = { ...store.state.selectShopVariantItem } || {}
          // {"serviceContent": { "lable": "6A", "code": "6A" },
          //   "oilType": { "lable": "AMG机油", "code": "AMG" }
          // }
          // 检查销售属性和属性值-是否在新的variantsListData范围内
          let ShopVariantTemp = _.mapValues(ShopVariantItem, function(item, attrName, object) {
            let attrObj = variantsListData.find(attr => attr.code === attrName)
            return attrObj && attrObj?.values.find(value => value.code === item.code) ? item : undefined
          })
          // store.commit('SETSELECTSHOPVARIANTITEM', _.pickBy(ShopVariantTemp, _.isObject))
        } else {
          // store.commit('SETSELECTSHOPVARIANTITEM', {})
        }
        // emit()
      }
    )
    watch(
      () => state.showTyreNum,
      async () => {
        let { currentGoodsInfo, dealerInfo, stepperOption } = store.state // 更新数据
        state.goodsInfo = currentGoodsInfo
        state.dealerInfo = dealerInfo
        // state.productNum = 1
        // store.commit('SETSTEPPEROPTION', {
        //   ...store.state.stepperOption,
        //   value: 1
        // })
        // let stockAmount = state.datas?._data?.stockAmount
        // if (state.from === 'tyreDetail') {
        state.productNum = stepperOption.value
        state.stepperNum = stepperOption.value || 1
        //   stockAmount = stepperOption.max
        // }
        // let max = Math.min.apply(Math, [stockAmount, 4])
        state.max = stepperOption.max || 99
        state.min = stepperOption.min || 1
        nextTick(async () => {
          state.isShow = true
        })
      }
    )
    watch(
      () => orderNoYes.value,
      n => {
        if (n) {
          store.dispatch('setCurrentCarInfo', {})
          state.isorderNo = true
          // initCarInfo()
        } else {
          state.isorderNo = false
          store.dispatch('setCurrentCarInfo', state.datas?.shopInfoDatas?.carInfo || {})
        }
        console.log('orderNoYes', n)
      }
    )
    watch(
      () => state.datas.carInfoTxt,
      n => {
        nextTick(() => {
          if (!n && !isEWProduct.value) {
            showToast('请绑车后再次操作')
          }
        })
      }
    )
    watch(
      () => store.state.dealerInfo,
      n => {
        // if (state.isShow && state.from === 'shoppingCar') {
        state.dealerInfo = n
        // const twoStock = Number(n.dealer_stock + n.two_hours_stock)
        // const nextStock = Number(n.dealer_stock + n.stock)
        // const maxStock = Math.max.apply(Math, [twoStock, nextStock])
        // let max = Math.min.apply(Math, [maxStock, 4])
        // state.max = isNaN(max) ? 0 : max
        // }
      }
    )
    watch(
      () => store.state.selectShopVariantItem,
      (selectShopVariantItem, old) => {
        state.selectVariantItemFirst = old
      },
      { deep: true }
    )
    watch(
      () => store.state.skuItem,
      // _.debounce(skuItem => {
      (skuItem, old) => {
        // console.log('store.state.skuItem-watch---pop------', skuItem)
        state.skuItem = skuItem
        if (old?.skuId !== skuItem?.skuId) {
          state.productNum = 1
        }
      },
      { deep: true }
    )
    watch(
      () => state.productNum,
      n => {
        if (state.min === 0) {
          !preView.value && state.isShow && state.skuItem?.skuId && showToast(state.noNtockMsg)
          return
        }
        store.commit('SETSTEPPEROPTION', {
          ...store.state.stepperOption,
          value: n
        })
        if (n >= state.max) {
          state.isShow && state.skuItem?.skuId && showToast(`商品加购件数已达到最大购买量${n}件`)
        }
      }
    )
    watch(
      () => store.state.stepperOption,
      n => {
        if (state.isShow && state.from === 'shopDetail') {
          state.max = isEWProduct.value ? 0 : Math.min.apply(Math, [n.max ? n.max : 0, 9999])
          state.min = Math.max.apply(Math, [n.min ? n.min : 1, 1])
        }
      }
    )
    const maxWatchHandle = max => {
      if (!isEWProduct.value && max < 1 && state.skuItem?.skuId) {
        !preView.value && state.isShow && showToast(state.noNtockMsg)
        state.min = 0
      } else {
        state.min = 1
      }
    }
    watch(
      () => state.max,
      n => {
        nextTick(async () => {
          maxWatchHandle(n)
        })
      },
      { immediate: true }
    )
    // 点击确认按钮
    const clickSureBtn = _.debounce(async () => {
      if (preView.value) {
        state.isShow = false
        return
      }
      if (state.from === 'shopDetail') {
        if (state.type === 'selectAttribut') {
          // 直接关闭
          state.isShow = false
          return
        }
      }
      if (!isChecking.value) {
        emit('clickSureBtn', { from: state.from, type: state.type })
      }
    }, 200)

    onMounted(async () => {
      // console.log('ConfirmShop---onMounted')
    })

    const beforeQuantityChange = () => {
      const isLoyalty = state.goodsInfo.productType == 1
      return new Promise((resolve) => {
        if(isLoyalty) {
          showToast('单店单次只能购买一件，如果想购买多件请分次购买')
          return resolve(false)
        }
        else {
          resolve(true)
        }
      });
    }

    return {
      ...toRefs(state),
      handleStep,
      initCarInfo,
      clickSureBtn,
      isChecking,
      variantsListData,
      currentSkuLis,
      salesAttributes,
      isShowAttributes,
      isShowChange,
      selectShopVariantItem,
      getPrice,
      closePop,
      preView,
      isEWProduct,
      viewContract,
      sureBtnDisableBool,
      beforeQuantityChange
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  padding: 15px 20px 0;
  text-align: left;
  max-height: 85vh;
  overflow-y: auto;
  padding-bottom: calc(60px + constant(safe-area-inset-bottom));
  padding-bottom: calc(60px + env(safe-area-inset-bottom));
  .van-cell {
    padding: 13px 0;
    border-style: solid;
    border-color: rgba(204, 204, 204, 0.5);
    border-width: 0.5px 0;
  }
  :deep(.van-field__label) {
    color: #333;
    font-weight: bold;
    margin-right: 0;
  }
  :deep(.van-field__control:disabled) {
    color: #333;
  }
}
.box::-webkit-scrollbar {
  display: none;
}

.title {
  padding: 5px 20px 20px;
  text-align: center;
  color: #333;
  font-weight: bold;
  font-size: 15px;
}
.van-field__label {
  width: 6em;
}
.goods {
  height: 80px;
  font-size: 14px;
  color: #333333;
  // padding-bottom: 20px;
  border-bottom: solid 1px #cccccc;
  margin-bottom: 16px;
}
.price {
  font-size: 14px;
  font-weight: 600;
  color: #3088c5;
  margin-top: 5px;
}
.imgBox {
  width: 72px;
  height: 72px;
  margin: 0 11px 10px;
  img {
    width: 72px;
    height: 72px;
  }
}
.fhlu {
  width: 100%;
  height: 100%;
}
.sectionBox {
  padding: 4px 0 0px;
  margin-bottom: 16px;
  overflow: auto;
  border-bottom: 1px solid rgba(204, 204, 204, 0.5);
  .row {
    margin-bottom: 12px;
  }
}

.btn {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: calc(10px + constant(safe-area-inset-bottom));
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
  background: #fff;
}
</style>
